import React from 'react'
import auvImage from './auvlogo2.jpg'
const AuvLogo = () => {
  return auvImage
}

export default AuvLogo
